import React from 'react';
import { useTypewriter, Cursor } from 'react-simple-typewriter';
import { motion } from 'framer-motion';
import { FaLinkedinIn, FaReact, FaGithub, FaProductHunt, FaNodeJs } from 'react-icons/fa';
import { SiTailwindcss, SiTypescript, SiNextdotjs, SiJavascript, SiExpress } from 'react-icons/si';

const LeftBanner = () => {
  const [text] = useTypewriter({
    words: ['Professional Coder.', 'software Developer.', 'Product Builder'],
    loop: true,
    typeSpeed: 20,
    deleteSpeed: 10,
    delaySpeed: 2000,
  });

  const fadeUpVariant = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
  };

  const containerVariant = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  return (
    <motion.div
      variants={containerVariant}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      className="w-full flex flex-col gap-10 max-w-5xl mx-auto items-center text-center"
    >
      {/* Introduction Section */}
      <motion.div variants={fadeUpVariant} className="flex flex-col gap-5 items-center">
        <h4 className="text-lg font-normal text-designColor tracking-widest uppercase font-titleFont">
          Welcome to my world
        </h4>
        <h1 className="text-6xl font-bold text-white font-titleFont">
          Hi, I&apos;m{' '}
          <motion.span
            className="text-designColor glitch-text cursor-pointer relative"
            whileHover={{ scale: 1.1 }}
          >
            Aditya Raj
          </motion.span>
        </h1>
        <h2 className="text-4xl font-bold text-white font-titleFont">
          a <span>{text}</span>
          <Cursor cursorBlinking="false" cursorStyle="|" cursorColor="#00f3ff" />
        </h2>
        <p className="text-base font-bodyFont leading-6 tracking-wide text-lightText/80 max-w-3xl mx-auto">
          I&apos;m Aditya Raj, a software developer and product builder focused on creating
          practical, user-first software. I work across the full product lifecycle—from shaping
          ideas and designing clean interfaces to building and scaling reliable systems. I&apos;m
          the founder of Retour, a real-time feedback platform that helps teams capture meaningful
          user input and turn it into clear, actionable insights. I value clean code, simple design,
          and thoughtful execution, and I aim to build products that solve real problems and deliver
          lasting value to users.
        </p>
      </motion.div>

      {/* Social Links and Skills Section */}
      <motion.div
        variants={fadeUpVariant}
        className="flex flex-col gap-10 items-center justify-center w-full"
      >
        {/* Social Links */}
        <div className="flex flex-col items-center gap-4">
          <h2 className="text-base uppercase font-titleFont tracking-widest text-gray-400">
            Find me on
          </h2>
          <div className="flex gap-4">
            <a href="https://github.com/Adityaraj223" target="blank">
              <span className="bannerIcon hover:text-designColor hover:shadow-neon hover:-translate-y-2 transition-all duration-300">
                <FaGithub />
              </span>
            </a>
            <a href="https://www.linkedin.com/in/aditya-raj-programmer-analyst/" target="blank">
              <span className="bannerIcon hover:text-designColor hover:shadow-neon hover:-translate-y-2 transition-all duration-300">
                <FaLinkedinIn />
              </span>
            </a>
            <a href="https://www.producthunt.com/@adityaraj007" target="blank">
              <span className="bannerIcon hover:text-designColor hover:shadow-neon hover:-translate-y-2 transition-all duration-300">
                <FaProductHunt />
              </span>
            </a>
          </div>
        </div>

        {/* Skills Icons */}
        <div className="flex flex-col items-center gap-4">
          <h2 className="text-base uppercase font-titleFont tracking-widest text-gray-400">
            BEST SKILLS
          </h2>
          <div className="flex gap-4 flex-wrap justify-center">
            {[
              { icon: <SiJavascript />, key: 'js' },
              { icon: <SiTypescript />, key: 'ts' },
              { icon: <FaReact />, key: 'react' },
              { icon: <SiNextdotjs />, key: 'next' },
              { icon: <FaNodeJs />, key: 'node' },
              { icon: <SiExpress />, key: 'express' },
              { icon: <SiTailwindcss />, key: 'tailwind' },
            ].map(item => (
              <span
                key={item.key}
                className="bannerIcon hover:text-designColor hover:shadow-neon hover:-translate-y-2 transition-all duration-300"
              >
                {item.icon}
              </span>
            ))}
          </div>
        </div>
      </motion.div>

      {/* SYSTEM Status */}
    </motion.div>
  );
};

export default LeftBanner;
